// The four enums the filter chips are drawn from, in the order src/lib/db/schema.ts
// declares them — which is the order the Next page renders them in and is NOT the order
// of the matching Ruby constants (Submission::STATUSES puts `draft` last).
import type {
  ReviewQualification,
  SubmissionCohort,
  SubmissionModality,
  SubmissionStatus,
} from '@/types';

export const submissionStatuses: SubmissionStatus[] = [
  'draft',
  'received',
  'priority_waiting',
  'asking_self_finance_trip',
  'approved',
  'onboarding_request',
  'onboarding_expired',
  'onboarding_complete',
  'rejected',
  'waiting_list',
  'withdrawn',
  'archived',
];

export const cohorts: SubmissionCohort[] = ['priority', 'final'];

export const submissionModalities: SubmissionModality[] = [
  'solo',
  'team',
  'team_looking',
];

export const reviewQualifications: ReviewQualification[] = [
  'hell_no',
  'no',
  'maybe',
  'yes',
  'hell_yes',
];
